
<template>
  <div style="height: 500px;overflow-y: auto;">
    <div v-for="(item) in pglist">
      <div class="pg_itype">{{item.itypeName}}</div>
      <div v-for="(child,i) in item.list">
        <div class="pg-every">{{child.name}}</div>
        <div>
          <el-radio-group v-model="child.itemVal">
              <el-radio :label="1">满意</el-radio>
              <el-radio :label="2">一般</el-radio>
              <el-radio :label="3">不满意</el-radio>
            </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['pgglid'],
    data() {
      return {
        pglist:[]
      }
    },
    created() {
      this.getPglist(this.pgglid);
    },
    methods: {
      getPglist(id) {
        this.$axios.get('/kt/ktAppraiseItem/getlist.htm?dataId=' + id).then(res => {
          var data = res.data;
          this.loading = false;
          if (data) {
            data.map((item) => {
              if (item.itemJson && JSON.parse(item.itemJson)) {
                item.list=JSON.parse(item.itemJson);
              };
            });
            this.pglist=data;
          } else {
            this.$message.error(data.message);
          }
        })
      }
    },
    watch:{
      pglist:{
        handler(val, oldVal) {
        },
        deep: true //true 深度监听
      }
    }
  }
</script>

<style>
  .pg_itype{
    border-left: 5px solid #0071ba;
    line-height: 35px;
    padding-left: 10px;
    font-size: 14px;
    font-weight: 800;
    background: rgba(0,113,186,0.1);
    margin: 15px 0 0px;
    letter-spacing: 1px;
  }
  .pg_itype:first{
    margin-top: 0;
  }
  .pg-every{
    font-size: 14px;
    padding-left: 15px;
    color: #333;
    font-weight: 800;
    margin: 15px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/MyPinggu.vue